import { render } from "./SubjectEdit.component.vue?vue&type=template&id=43130650&scoped=true&ts=true"
import script from "./SubjectEdit.component.vue?vue&type=script&lang=ts"
export * from "./SubjectEdit.component.vue?vue&type=script&lang=ts"

import "./SubjectEdit.component.vue?vue&type=style&index=0&id=43130650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43130650"]])

export default __exports__